import api from '../utils/api';

export default {
  fetch: () => api({ endpoint: 'todo' }),
  poll: () => api({ endpoint: 'todo', interval: 2000 }),
};
